import InventoryOutlined from '@mui/icons-material/InventoryOutlined';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const inventoryConfig: IProductConfig = {
  baseUrlProd: routes.ivProd,
  baseUrlSandbox: routes.ivSandbox,
  icon: <InventoryOutlined />,
  modules: [
    {
      label: 'Items',
      pageTitle: 'Items',
      path: '/items',
      roles: ['InventoryAdmin', 'InventorySenior', 'InventoryService', 'InventoryStandard'],
    },
    {
      label: 'Product Hub',
      pageTitle: 'Product Hub',
      path: '/product-hub',
      customRoutes: [routes.prSandbox, routes.prSandbox, routes.prProd],
      roles: ['InventoryAdmin', 'ProductManagementStandard'],
    },
  ],
  product: EProduct.inventory,
  title: 'Inventory',
};

export default inventoryConfig;
